// Navbar, Sidebar & Auth
import { Outlet }         from 'react-router-dom';
import { DesktopSidebar } from 'components/DesktopSidebar/DesktopSidebar';
import { DesktopNavbar }  from 'components/DesktopNavbar/DesktopNavbar';
import { MobileNavbar }   from 'components/MobileNavbar/MobileNavbar';
import {Helmet}           from "react-helmet";
import AuthService        from 'services/auth.service';

function WithNavigation(props) {
  const currentUser       = AuthService.getCurrentUser();
  window.specialization = "Pediatrics";
  if(currentUser && currentUser.specialties && currentUser.specialties.length !== 0){ 
    window.specialization = currentUser.specialties[0].name
  }
  return (
    <div>
      <DesktopSidebar />
      <DesktopNavbar dropdownDisplayed={ props.dropdownDisplayed } />
      <MobileNavbar />
      <Outlet/>
      { currentUser && currentUser.user_type === 'doctor' &&
        <Helmet>
          <script>
            {`
              try{
                docereeAds.add("userDetails", {
                  "userconsent": "1", 
                  "specialization": window.specialization
                })
              }catch(err){
                console.log(err)
              }
            `}
          </script>
        </Helmet>
      }
    </div>
  );
}

export default WithNavigation;